var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0a972f4c7b6d8fc271e9ae07dae4b4400f64e9ef"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["umb@umb"]={id:"0a972f4c7b6d8fc271e9ae07dae4b4400f64e9ef"};
      